// src/components/LocalizedLink.jsx
import { Link, useParams } from "react-router-dom";

export default function LocalizedLink({ to = "", ...props }) {
  const { lng } = useParams();
  const normalized = to.startsWith("/") ? to : `/${to}`;
  const href = `/${lng}${normalized}`;
  return <Link to={href} {...props} />;
}
